module.exports = __webpack_public_path__ + "static/media/arrow-right.c0316b16.svg";